import { css, html, LitElement } from 'lit';

class MentionUserList extends LitElement {
  static properties = {
    users: { type: Array },
    isVisible: { type: Boolean },
    searchQuery: { type: String },
    onSelectUser: { type: Function },
    fromAttachment: { type: Boolean },
    userMetaData: { type: Object }
  };

  constructor() {
    super();
    this.users = [];
    this.isVisible = false;
    this.searchQuery = '';
    this.onSelectUser = null;
    this.fromAttachment = false;
  }

  static styles = css`
    :host {
      display: block;
      width: 100%;
    }

    .mention-list-container {
      position: absolute;
      bottom:100%;
      left: 0;
      width: 100%;
      max-height: 200px;
      background-color: var(--bg-primary-color, #ffffff);
      border-radius: 10px;
      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
      overflow-y: auto;
      z-index: 100;
      margin-bottom: 10px;
      animation: slideUp 0.2s ease-out;
    }
    .mention-list-container-attachment {
      position: absolute;
      bottom: 90%;
      left: 0;
      width: 100%;
      max-height: 200px;
      background-color: var(--bg-primary-color, #ffffff);
      border-radius: 10px;
      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
      overflow-y: auto;
      z-index: 100;
      margin-bottom: 10px;
      animation: slideUp 0.2s ease-out;
    }

    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .mention-list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .mention-item {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      cursor: pointer;
      transition: background-color 0.2s ease;
    }

    .mention-item:hover, .mention-item.selected {
      background-color: var(--bg-secondary-color, #f0f2f5);
    }

    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 12px;
      background-color: #ddd;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      color: #666;
      overflow: hidden;
    }

    .user-avatar img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .user-info {
      flex: 1;
    }

    .user-name {
      font-weight: 500;
      color: var(--text-primary-color, #000);
      margin-bottom: 2px;
    }

    .user-status {
      font-size: 13px;
      color: var(--text-secondary-color, #667781);
    }

    .no-results {
      padding: 16px;
      text-align: center;
      color: var(--text-secondary-color, #667781);
    }

    .search-highlight {
      background-color: rgba(var(--primary-color-rgb, 0, 132, 255), 0.2);
      font-weight: 500;
    }
  `;

  getFilteredUsers() {
    if (!this.searchQuery) return this.users.filter(user => user.userId !== this.userMetaData.userId); // First remove the current user if no search query

    const query = this.searchQuery.toLowerCase();
    return this.users
      .filter(user => user.userId !== this.userMetaData.userId) // Remove the current user first
      .filter(user => user.userName.toLowerCase().includes(query)); // Then apply the search query
  }



  handleUserClick(user) {
    if (this.onSelectUser) {
      this.onSelectUser(user);
    }
  }

  highlightMatches(name, query) {
    if (!query) return name;
    
    const index = name.toLowerCase().indexOf(query.toLowerCase());
    if (index === -1) return name;
    
    const beforeMatch = name.substring(0, index);
    const match = name.substring(index, index + query.length);
    const afterMatch = name.substring(index + query.length);
    
    return html`${beforeMatch}<span class="search-highlight">${match}</span>${afterMatch}`;
  }

  render() {
    if (!this.isVisible) return html``;

    const filteredUsers = this.getFilteredUsers();

    return html`
      <div class=${`${this.fromAttachment ? 'mention-list-container-attachment' : 'mention-list-container'}`}>
        ${filteredUsers.length === 0 
      ? null
          : html`
            <ul class="mention-list">
              ${filteredUsers.map((user) => html`
                <li class="mention-item" @click=${() => this.handleUserClick(user)}>
                  <div class="user-avatar">
                    ${user.userProfileImageUrl 
                      ? html`<img src="${user.userProfileImageUrl}" alt="${user.userName}" />`
                      : user.userName.substring(0, 2).toUpperCase()
                    }
                  </div>
                  <div class="user-info">
                    <div class="user-name">${this.highlightMatches(user.userName, this.searchQuery)}</div>
                  </div>
                </li>
              `)}
            </ul>
          `}
      </div>
    `;
  }
}

customElements.define('mention-user-list', MentionUserList);